import { create } from 'zustand';

// Holds the prompt for an in-flight report build, purely for display: the
// build itself runs as a normal assistant-panel chat. Submitting on /reports
// sets it and navigates to /reports/new, which paints it on the placeholder
// and consumes it on unmount. A hard refresh or direct hit on /reports/new
// finds an empty store and redirects back to /reports.
const useReportBuildStore = create((set) => ({
    prompt: null,
    startBuild: (prompt) => set({ prompt }),
    clearBuild: () => set({ prompt: null }),
}));

export default useReportBuildStore;
